<template>
  <el-dialog
    class="btn-close login-dailog"
    :title="title"
    :append-modelody="true"
    :modal-append-to-body="false"
    width="470px"
    top="50px"
    :visible="dialogVisible"
    @close="onCancel"
  >
    <loginControl
      :initOpen="dialogVisible"
      ref="loginRef"
      :toTab="toTab"
      @close="onCancel"
    ></loginControl>
  </el-dialog>
</template>

<script>
import loginControl from '@/components/account/client'
export default {
  props: ['dialogVisible', 'title', 'toTab'],
  components: {
    loginControl,
  },
  watch: {
    toTab(now) {
      console.log(now)
    },
  },
  methods: {
    onConfirm() {
      this.$emit('onConfirm')
    },
    onCancel() {
      this.$emit('onCancel')
    },
  },
}
</script>
<style lang="scss" >
.login-dailog {
  .el-dialog__header {
    padding: 0px 20px 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/login-dialog.vue